/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerFindOneQueryResponse, RolesControllerFindOnePathParams, RolesControllerFindOne400, RolesControllerFindOne401, RolesControllerFindOne403, RolesControllerFindOne404 } from "../../models/rolesController/RolesControllerFindOne";

function getRolesControllerFindOneUrl(id: RolesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/roles/${id}` as const }  
  return res
}

/**
 * @summary Get a single role with its granted permission rules
 * {@link /api/v1/roles/:id}
 */
export async function rolesControllerFindOne(id: RolesControllerFindOnePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<RolesControllerFindOneQueryResponse, ResponseErrorConfig<RolesControllerFindOne400 | RolesControllerFindOne401 | RolesControllerFindOne403 | RolesControllerFindOne404>, unknown>({ method : "GET", url : getRolesControllerFindOneUrl(id).url.toString(), ... requestConfig })  
  return res.data
}